import { Controller } from "@hotwired/stimulus"

// Submits GET index filter forms when a control changes (select, text on blur).
// Date range fields submit via the popover Apply button (date-range-picker#apply).
export default class extends Controller {
  submit (event) {
    const { target } = event
    if (target.closest("[data-controller~='date-range-picker']")) return
    if (target.matches("[data-date-range-picker-target]")) return

    this.element.requestSubmit()
  }
}
